import { useLocation } from 'react-router-dom';

import useTranslation from 'customHooks/translate';

import { titleLinks } from './titles';

const SecondaryHeader = () => {
  const location = useLocation();
  const translation = useTranslation();

  const links = titleLinks(translation);
  const currentLink = links?.find((link) =>
    location.pathname.startsWith(link?.url)
  );

  if (!currentLink) return null;

  return (
    <div className="flex h-[81px] w-full items-center gap-[12px] border-b border-b-[#f5f7f9] px-[16px] py-[14px] md:hidden">
      <img
        className="h-[20px] w-[20px]"
        src={`assets/dashboard-icon.svg`}
        alt=""
      />
      <p className="text-[16px] font-semibold text-[#1D1D1D]">
        {currentLink?.name}
      </p>
    </div>
  );
};

export default SecondaryHeader;
